import {
  computed,
  markRaw,
} from 'vue';

import {
  TheLayout,
  useAuthorization,
  useRouter,
} from '@sttedra_ui/framework';

import {useStorage} from '@vueuse/core';

const {modelRef: authorizationModelRef} = useAuthorization();
const router = useRouter();

export default class AppViewState {
  // #region App
  isOffline = Number(STTEDRA_OFFLINE) ? true : false;
  offlineYear = STTEDRA_OFFLINE_YEAR ?? '';
  offlineText = STTEDRA_OFFLINE_TEXT ?? '';
  // #endregion

  // #region Layout
  isMenuCollapsed = true;
  layout = computed(() => markRaw(router.currentRoute.value.meta?.layout || TheLayout));
  roles = computed(() => authorizationModelRef.value.roles?.join(', ') || null);
  // breadCrumbs = computed(() => router.currentRoute.value.meta?.staticBreadCrumbs?.() || []);
  // #endregion

  // #region Authorization
  isLogged = useStorage('isLogged', false, localStorage);
  token = useStorage('token', null, localStorage);
  errorInLogin = null;
  // #endregion

  // #region STATUS
  isLoading = false; // App is loading
  inProgress = false; // App is in progress
  // #endregion

  // #region Register
  isTutorizeRegister = false;
  isTutorizeRegisterRedirect = false;
  // #endregion

  // #region Temporal data
  currentRequest = null;
  detailRequest = null;
  countryEU = [];
  // #endregion

  defaultStateApp() {
    this.isLoading = false;
    this.inProgress = false;

    this.errorInLogin = null;
    this.isLogged = false;
    this.token = null;

    this.cleanTemporalData();
  }

  setLoginApp(isLogin) {
    this.isLoading = isLogin === true;
    this.inProgress = isLogin === true;
  }

  cleanTemporalData() {
    this.currentRequest = null;
    this.detailRequest = null;
  }
}
